module.exports = __webpack_public_path__ + "img/ai-assistant-qr-2026.d6d140a6.png";